import { format } from 'date-fns';

/**
 * Return ellipsis of a given string
 * @param {string} text
 * @param {number} size
 */
const ellipsis = (text, size) => {
  return `${text.split(' ').slice(0, size).join(' ')}...`;
};

const idGenerator = (events, length = 1) => {
  const arrayData = [];
  events.map((data) => {
    return arrayData.push(parseInt(data.id, 10));
  });
  const number = (Math.max(...arrayData) + 1).toString();
  return number.length < length ? `${'0'.repeat(length - number.length)}${number}` : number;
};

export { ellipsis, idGenerator };

export const getQueryString = (params) => {
  const query = Object.keys(params).filter(
    (key) => params[key] !== undefined && params[key] !== null && params[key] !== '',
  );
  return query.map((key) => `${key}=${params[key]}`).join('&');
};

export const UsersRole = {
  SUPER_ADMIN: 'super_admin',
  SUB_ADMIN: 'sub_admin',
  FINANCE: 'finance',
  CUSTOMER: 'customer',
};
export const AvailabePermissions =
  'BOOKING_VIEW,BOOKING_EDIT,CUSTOMER_VIEW,CUSTOMER_EDIT,ADMIN_USER_VIEW,ADMIN_USER_EDIT,ADMIN_USER_ADD,FINANCE_VIEW';

export const UsersPermissions = {
  edit_customer: 'CUSTOMER_EDIT',
  view_customer: 'CUSTOMER_VIEW',
  view_booking: 'BOOKING_VIEW',
  edit_booking: 'BOOKING_EDIT',
  view_admin_user: 'ADMIN_USER_VIEW',
  edit_admin_user: 'ADMIN_USER_EDIT',
  add_admin_user: 'ADMIN_USER_ADD',
  view_finance: 'FINANCE_VIEW',
};

export const formatCurrency = (amount, symbol = '', decimalPlaces) => {
  if (!Number(amount) && typeof amount === 'string') {
    return amount;
  }
  // 1. Normalize input: strip commas if string, then coerce
  let num = typeof amount === 'string' ? parseFloat(amount.replace(/,/g, '')) : Number(amount);

  // 2. Bail out on non-numeric
  if (!Number.isFinite(num)) return '';

  // 3. Remember sign, work with absolute value
  const sign = num < 0 ? '-' : '';
  num = Math.abs(num);

  // 4. Determine decimal places: passed → use it, not passed → whole number or amount's decimals
  let places;
  if (decimalPlaces !== undefined) {
    places = decimalPlaces;
  } else if (num % 1 !== 0) {
    // Not passed and amount has decimals (e.g. 125.33): preserve them
    const decStr = String(num).split('.')[1] || '';
    places = decStr.length;
  } else {
    places = 0;
  }

  // 5. toFixed and split into integer + dec parts
  const [intPart, decPart] = num.toFixed(places).split('.');

  // 6. Insert commas every three digits
  const withCommas = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  // 7. Reassemble (omit decimal part when whole number)
  const decimalSuffix = places > 0 ? `.${decPart}` : '';
  return `${sign}${symbol}${withCommas}${decimalSuffix}`;
};

/**
 * Format ISO date string to a custom format
 * @param {string} isoDate - Date in ISO format (e.g. "2025-02-07T10:30:00.000Z")
 * @param {string} format - Output format with tokens: DD (day), MM (month), YYYY (year), h (12h), i (min), A (AM/PM). Default: "M d, Y h:i A"
 * @returns {string} Formatted date string
 */
export const formatDate = (isoDate, targetFormat = 'MMM dd, yyyy hh:mm a') => {
  // Parse the ISO date string and format it using date-fns
  const dateObj = new Date(isoDate);

  // Return the formatted date string
  return format(dateObj, targetFormat);
};

export const truncateString = (str = '', maxLength = 20) => {
  if (str?.length > maxLength) {
    return `${str.substring(0, maxLength)}...`;
  }
  return str;
};
